import React from 'react'
import type { AnalysisPostAttachment } from '../services/analysisPostAttachmentsService'
import {
  PostPreviewCard,
  type LightboxVariant,
  type PostAttachment,
} from '@/modules/post-shared'

type AnalysisPostPreviewCardProps = {
  title: string
  contentHtml: string
  attachments: AnalysisPostAttachment[]
  lightboxVariant?: LightboxVariant
  footer?: React.ReactNode
  className?: string
}

function mapToPostAttachments(
  attachments: AnalysisPostAttachment[],
): PostAttachment[] {
  return (attachments || [])
    .filter((att) => att && att.url)
    .map((att) => ({
      id: att.id,
      postId: att.analysisId,
      url: att.url,
      storageBucket: att.storageBucket ?? null,
      storagePath: att.storagePath ?? null,
      contentType: att.contentType ?? null,
      sizeBytes: att.sizeBytes ?? null,
      createdAt: att.createdAt,
    }))
}

export function AnalysisPostPreviewCard({
  title,
  contentHtml,
  attachments,
  lightboxVariant,
  footer,
  className,
}: AnalysisPostPreviewCardProps) {
  const mappedAttachments = React.useMemo(
    () => mapToPostAttachments(attachments),
    [attachments],
  )

  return (
    <PostPreviewCard
      title={title}
      contentHtml={contentHtml}
      attachments={mappedAttachments}
      lightboxVariant={lightboxVariant}
      footer={footer}
      className={className}
    />
  )
}
